import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const CardData = () => {
  const { t } = useLocalize()
  return <div>{t('driverModule.card-data-title')}</div>
}

export default CardData
